import SettingsPage from "@Components/game/settings/settings-page";
import SettingsSwitch from "@Components/game/settings/toggles/settings-switch";
import Section from "@Containers/shared/cards/section";
import { AnalyticsEvents, Preferences } from "@Enums/index";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import useGameSettings from "@hooks/common/settings/use-game-settings";
import useI18n from "@i18n";
import { Stack } from "@mui/material";

const feedbackDefaults = {
  [Preferences.feedback_text_scan_critical]: false,
  [Preferences.feedback_text_decision]: false,
  [Preferences.feedback_voice_scan_rate]: false,
  [Preferences.feedback_voice_scan_timing]: false,
  [Preferences.feedback_voice_scan_critical]: false,
  [Preferences.feedback_voice_awareness]: false,
  [Preferences.feedback_voice_decision]: false,
};

const feedbackSections = [
  {
    title: "settings.feedback.section.text",
    fields: [
      { id: Preferences.feedback_text_scan_critical, label: "settings.feedback.text.critical" },
      { id: Preferences.feedback_text_decision, label: "settings.feedback.text.decisions" },
    ],
  },
  {
    title: "settings.feedback.section.voice",
    fields: [
      { id: Preferences.feedback_voice_scan_rate, label: "settings.feedback.voice.scan-rate" },
      { id: Preferences.feedback_voice_scan_timing, label: "settings.feedback.voice.scan-timing" },
      { id: Preferences.feedback_voice_scan_critical, label: "settings.feedback.voice.critical" },
      { id: Preferences.feedback_voice_awareness, label: "settings.feedback.voice.awareness" },
      { id: Preferences.feedback_voice_decision, label: "settings.feedback.voice.decisions" },
    ],
  },
] as const;

const FeedbackSettings = () => {
  const { i18n } = useI18n();
  const { track } = useAnalytics();
  const { values, setValue, ready, error, refetch } = useGameSettings(feedbackDefaults, {
    onPersist: values =>
      track(AnalyticsEvents.in_game_feedback_settings_changed, {
        useTextCritical: values[Preferences.feedback_text_scan_critical],
        useTextDecisions: values[Preferences.feedback_text_decision],
        useVoiceScanRate: values[Preferences.feedback_voice_scan_rate],
        useVoiceScanTiming: values[Preferences.feedback_voice_scan_timing],
        useVoiceCritical: values[Preferences.feedback_voice_scan_critical],
        useVoiceAwareness: values[Preferences.feedback_voice_awareness],
        useVoiceDecisions: values[Preferences.feedback_voice_decision],
      }),
  });

  return (
    <SettingsPage id="SETTINGS-FEEDBACK" title={i18n("settings.feedback.title")} ready={ready} error={error} refetch={refetch}>
      {feedbackSections.map(({ title, fields }) => (
        <Section key={title} title={i18n(title)}>
          <Stack spacing={1.5}>
            {fields.map(({ id, label }) => (
              <SettingsSwitch key={id} label={i18n(label)} checked={values[id]} onChange={(_event, value) => setValue(id, value)} />
            ))}
          </Stack>
        </Section>
      ))}
    </SettingsPage>
  );
};

export default FeedbackSettings;
